import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Tooltip, Badge, Avatar, Dropdown,Drawer,Modal,Space,Button, Popover } from 'antd';
import { useNotificationListTemplate } from 'hooks/notification/notificationList';
import { _GLOBAL } from '../../../consts';
import { UserOutlined } from '@ant-design/icons';
import { jsonParseData } from '../../../utils';




const { confirm } = Modal;

interface props {
    username?: any
    enums?:any
    supplierName?:any
}
const QRCode = () => {
  const Content = () => {
    return (
      <div >
        <div>微信扫码关注公众号，更方便接收系统消息！</div>
        <div style={{ display:'flex',justifyContent:'center'}}>
            <img style={{width:'220px'}} alt='' src='https://dpubstatic.udache.com/static/dpubimg/ICzknLKi3L0E05cIPO1I9_qrcode_for_gh_341ec67740e7_430.jpg'>
            </img>
        </div>
      </div>
    );
  };
  return (
    <Popover content={Content}>
      <span style={{ color: "white",cursor:'pointer' }}>公众号</span>
    </Popover>
  );
};
const SPHeader: React.FC<props> = (props) => {
    const { username, enums,supplierName } = props;

    const [count, setCount] = useState<number>(0);
    const { pollingMsg, getSaasApolloConfig,search } = useNotificationListTemplate();
    const [open, setOpen] = useState(false);
    const [helpDocList, setHelpDocList] = useState<any>([])
    const [messages, setMessages] = useState<any>([]);


    const getMsg = () => {
        pollingMsg({ read_status: 1 }).then((res: any) => {
            setCount(res.data?.count);
        });
    };

    const items = [
        { label: <>{username}</>, key: 'username' },
        { label: <a href={_GLOBAL.URL.LOGOUT}>退出登录</a>, key: 'logout' },
    ];

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        getSaasApolloConfig({
            config_name: 'front_enums',
            param_name: 'f_help_doc_list',
        }).then((res: any) => {
            setHelpDocList(jsonParseData(res.data?.f_help_doc_list, []));
        });
        getMsg();
        setInterval(() => {
            getMsg();
        }, 10 * 1000);
    }, []);

    return (
        <>
            <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
                <div className='logoBody'>
                    <div className="logo"/>
                    <div className='supplierName'>
                        {supplierName}
                    </div>
                </div>
                <div style={{display: 'flex', width: 300, justifyContent: 'space-between', alignItems: 'center'}}>
                {/* <Tooltip color="white" placement="bottom" overlayStyle={{maxWidth:600}}  title={<img style={{width:200,height:200}}  src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/qr.jpg"/>}>
								<img src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/phone.png"/><span style={{color:'white'}}>手机端</span>
						</Tooltip> */}
                        <QRCode></QRCode>
						<div onClick={showDrawer} style={{display:'flex',alignItems:'center',cursor:'pointer'}}>
								<img src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/doc.png"/>
                                <span style={{color:'white',marginLeft:'4px'}}>帮助文档</span>
						</div>
						<Badge count={count}>
							<NavLink to="/notification/notificationList">
								<img src="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/msg.png"/>
							</NavLink>
						</Badge>
						<Dropdown menu={{ items }}>
							<Avatar icon={<UserOutlined />} />
						</Dropdown>
					</div>
            </div>
            <Drawer title="帮助文档" placement="right" onClose={onClose} open={open}>
                {helpDocList.map((item: any,index:any) => {
                    return <div key={index} style={{
                        width: '98%',
                        height: '40px',
                        lineHeight: '40px',
                        boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
                        marginBottom: 10,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: '#FF6400',
                        boxSizing: 'border-box',
                        padding: '0 10px',
                    }}><a onClick={() => {
                        window.open(item.url);
                    }}>{index + 1 + '、' + item.name}</a></div>
                })}
            </Drawer>
        </>
    )

}

export default SPHeader
